<template>
    <div class="col-12 md:col-6">
        <div v-for="item in items?.slice()?.reverse()" :key="item.id" class="surface-card shadow-2 p-3 border-round">
            <div class="flex justify-content-between mb-3">
                <div>
                    <span class="block text-600 font-bold mb-2">{{ item.name }}</span>
                    <div class="text-900 font-medium text-xl">{{ getTotal(item.id) }}</div>
                </div>
                <div class="flex align-items-center justify-content-center border-round" :class="item.color" style="width: 2.5rem; height: 2.5rem">
                    <i :class="['pi', item.icon]" class="text-white text-xl"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { getAllPriorities, getAllProgress } from '../../product/ams/constants';

const props = defineProps({
    reportType: {
        type: String,
    },
    boxType: {
        type: String,
    },
    chartData: {
        type: Array,
    },
});

const items = computed(() => {
    if (props.boxType == 'progress') {
        return getAllProgress();
    } else {
        return getAllPriorities();
    }
});

const getTotal = (id) => {
    if (props.chartData && props.chartData?.length > 0) {
        if (props?.boxType == 'progress') {
            const progress = props.chartData?.find((item) => item.progress == id);
            return progress?.tot ?? 0;
        } else {
            const priority = props.chartData?.find((item) => item.priority == id);
            return priority?.tot ?? 0;
        }
    }
    return 0;
};
</script>
